<template>
  <Layout>
    <div class="page-header">
      <div class="page-title">
        <h2>{{$t('journeys_name')}}</h2>
        <h5>{{$t('select_program_and_manage_journey')}}</h5>
      </div>

      <div class="actions">
        <TableDownload
            :data="tableData.data"
            :fields="['name', 'description', 'userAssignedCount', 'totalUserStarted', 'totalUserNotStarted', 'startAt', 'finishAt']"
            :headers="{
            name: $t('program'),
            description: $t('description'),
            userAssignedCount: $t('assigned_users'),
            totalUserStarted:$t('users_started'),
            totalUserNotStarted:$t('users_not_started'),
            startAt:$t('start_at'),
            finishAt:$t('finish_at'),
            }"
            :computed-fields="{
            startAt: (item) => formatDate(item.startAt),
            finishAt: (item) => formatDate(item.finishAt),
            }"
            :filename="$t('journey_program_report')"
        />
        <ExpandableSearch />
      </div>
    </div>

    <div class="table-holder">
      <journey-program-table
          :programs="tableData.data"
          :loading="isLoading"
          :current-sort="currentSort"
          :on-sort="handleSort"
      />

      <div class="pagination-align-center">
        <Pagination :total-items="tableData.total" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import Pagination from "@/components/Pagination.vue";
import JourneyUserTable from "@/components/tables/Journey/JourneyUserTable.vue";
import UserTable from "@/components/tables/User/UserTable.vue";
import journeyService from "@/service/journeyService";
import {handleErrorResponse} from "@/utils/utils";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import JourneyUserFilters from "@/components/tables/Journey/JourneyUserFilters.vue";
import JourneyProgramTable from "@/components/tables/Journey/JourneyProgramTable.vue";
import programService from "@/service/programService";
import TableDownload from "@/components/TableDownload.vue";

export default {
  name: 'Journeys',
  components: {
    TableDownload,
    JourneyProgramTable,
    JourneyUserFilters,
    ExpandableSearch,
    UserTable,
    JourneyUserTable,
    Pagination,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      data: {},
      tableData: {
        data: [],
        total: 0
      },
      currentPage: 1,
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });

      this.handlePage(1);
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;

      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        const orderByArray = [{
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        }];

        tempFilters.push({
          key: 'orderBy',
          value: orderByArray
        });

        this.currentSort = {
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        };
      }

      programService.getAssignedJourneyPrograms(page, tempFilters).then((res) => {
        this.tableData.data = res.data.data.data;
        this.tableData.total = res.data.data.total;
        this.isLoading = false;
      }).catch((error) => {
        handleErrorResponse(error, this.$snackbar);
        this.isLoading = false;
      });
    }
  },
  mounted() {
    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  }
}
</script>

<style scoped>
.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.icon-holder img {
  cursor: default;
}

.table-title {
  font-family: 'euclid_medium', sans-serif;
  color: #040C2D;
  position: sticky;
  background: white;
}

.table-holder {
  margin-top: 20px;
}
</style>
